import { render, staticRenderFns } from "./treeList.vue?vue&type=template&id=bc1441aa&"
import script from "./treeList.js?vue&type=script&lang=js&"
export * from "./treeList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports